

const handleUpdate = (dispatch) => (packet) => {
  const title = packet?.title;
  const doc = packet?.data?.doc;
  console.log("update")
  console.log("totle",title)
  console.log("doc",doc)
  if (!doc) return;
  switch (title) {
    case "Table":
    //   dispatch(addTableSuccess({ data: { doc } }));
      break;
    default:
      return;
  }
};

export default handleUpdate;
